const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'templates',
		'routeContentTrees',
		'routeContentTrees'
	],

	config: {
		mode: 'chooser',
		treeTypeComponents: {
			default: [
				'/',
				'templates',
				'routeContentTrees',
				'duplicateMasterComponentSelectRouteContentTree'
			]
		},
		nodeActionMapping: {
			defaultBaseActions: {
				select: {
					layout: 'duplicateMasterComponent_component',
					section: 'duplicateMasterComponent_component',
					component: 'duplicateMasterComponent_component'
				},
				deselect: {
					layout: 'duplicateMasterComponent_component',
					section: 'duplicateMasterComponent_component',
					component: 'duplicateMasterComponent_component'
				}
			}
		}
	},

	methods: {
		duplicateMasterComponent: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, data){
			if(buttonContext === 'component'){
				var nodeData = this.getSelectedNodeData();
				if(nodeData){
					// emulate decision like ordinary selectComponentTrees does
					const triggerFound = this.triggerClosest(
						'onDecision',
						{
							data: 				nodeData,
							decisionType: 		'submit',
							decisionOptions: 	{ wasMassInsert: utils.keyboard.keysActive('strg') },
							decisionComponent: 	this
						},
						'templates_routeContentTrees_routeContentTrees'
					);

					// deselect active node for mass insert speedup
					this.deselectActiveNode();

					return triggerFound;
				}
			}

			this.deselectActiveNode();
			return this.performAction(
				this.prepareAction('message', undefined, {
					messageDisplay: {
						message: 'error:routeContentTree.duplicateMasterComponent.invalidElementType'
					}
				})
			);
		}
	}
};
